module.exports = __webpack_public_path__ + "static/media/test.8242367d.JPG";